import React from 'react';
import { H2 } from '@vp/swan';
import PropTypes from 'prop-types';

export const OrderDetailsCardHeading = ({ testId, children }) => (
  <H2 fontSize="standard" fontWeight="bold" data-testid={testId}>
    {children}
  </H2>
);

OrderDetailsCardHeading.propTypes = {
  testId: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
